module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_2-0cee4e043ad9b1b4d57ac10b5665457b.png";